import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=d0885aea&scoped=true&"
import script from "./CategoryDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=d0885aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0885aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0885aea')) {
      api.createRecord('d0885aea', component.options)
    } else {
      api.reload('d0885aea', component.options)
    }
    module.hot.accept("./CategoryDialog.vue?vue&type=template&id=d0885aea&scoped=true&", function () {
      api.rerender('d0885aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoods/components/CategoryDialog.vue"
export default component.exports